import { PDFDownloadLink } from '@react-pdf/renderer'
import React from 'react'
import DownloadRFQPDF from './DownloadRFQPDF';
import { CreateButton } from '../../../../../Components/Utils/Buttons';

function PDFLinkRFQ({headers,data,fileName}) {
    // console.log("headerssss",headers);
  return (
    <PDFDownloadLink document={<DownloadRFQPDF header={headers} data={data} />} fileName={fileName}>
    {({ blob, url, loading, error }) =>
      loading ? (
        "..."
      ) : (
        <CreateButton svg={false} label="Download as PDF" />
      )
    }
  </PDFDownloadLink>
  )
}

export default PDFLinkRFQ